//
// TikTok RapidAPI search lanes for the router (plan §5): BestExperience + LiveAPI are the search
// lanes (family 'rapidapi' — one pooled key), scraper7 is registered but flag-off until it
// answers 200 again (403 since 10/2026). They wrap the existing provider classes' strict user-search method;
// the router bounds each call (5.5 s for TikTok) and passes its abort signal.
//

import type { Provider } from '../../router/registry';

type LaneClass = { fetchUserSearchStrict(query: string, limit: number, signal?: AbortSignal): Promise<any[]> };

/** The provider classes and the tiktok barrel import each other: evaluate the barrel first (safe order). */
const viaBarrel = async <T>(load: () => Promise<T>): Promise<T> => { await import('../index'); return await load(); };

function lane(id: string, seedLatencyMs: number, load: () => Promise<LaneClass>, defaultEnabled = true): Provider {
	return {
		id,
		platform: 'tiktok',
		capabilities: ['search_users'],
		family: 'rapidapi',
		transport: 'rapidapi',
		requiresToken: false,
		seedLatencyMs,
		defaultEnabled,
		parser: (body) => body,
		// Strict by design: `[]` comes back only when the provider's reply really carried a user_list. A throttle, a
		// block page or a schema change THROWS (a lane failure) instead of masquerading as "no results".
		execute: async (req, signal) => await (await viaBarrel(load)).fetchUserSearchStrict(req.query, req.limit, signal),
	};
}

export const TikTokBestExperienceLane = lane('tt_bestexperience', 7500, async () => new (await import('./TikTokBestExperience')).default() as unknown as LaneClass);
export const TikTokLiveAPILane = lane('tt_liveapi', 4151, async () => new (await import('./TikTokLiveAPI')).default() as unknown as LaneClass);
export const TikTokScraper7Lane = lane('tt_scraper7', 3000, async () => new (await import('./TikTokScraper')).default() as unknown as LaneClass, false);
// Free anonymous donor (profile capability): declared in its own file, listed here so the TikTok lanes read as one set.
export { HighSocialTikTokLane } from './HighSocialTikTok';
